export const mockViewResponse = {
  success: true,
  signupList: {
    ID: 5,
    title: "MemberType: Per Slot",
    description:
      "<p>Laborum eu non cupidatat aliquip et id ad in pariatur id nulla qui velit. Ut aute officia elit eiusmod aliquip voluptate do aute dolor Lorem cupidatat magna culpa tempor quis.</p><p>Laborum eu non cupidatat aliquip et id ad in pariatur id nulla qui velit. Ut aute officia elit eiusmod aliquip voluptate do aute dolor Lorem cupidatat magna culpa tempor quis.</p><p>Laborum eu non cupidatat aliquip et id ad in pariatur id nulla qui velit. Ut aute officia elit eiusmod aliquip voluptate do aute dolor Lorem cupidatat magna culpa tempor quis.</p> <p>Laborum eu non cupidatat aliquip et id ad in pariatur id nulla qui velit. Ut aute officia elit eiusmod aliquip voluptate do aute dolor Lorem cupidatat magna culpa tempor quis.</p><p>Laborum eu non cupidatat aliquip et id ad in pariatur id nulla qui velit. Ut aute officia elit eiusmod aliquip voluptate do aute dolor Lorem cupidatat magna culpa tempor quis.</p><p>Laborum eu non cupidatat aliquip et id ad in pariatur id nulla qui velit. Ut aute officia elit eiusmod aliquip voluptate do aute dolor Lorem cupidatat magna culpa tempor quis.</p>",
    // darkMode
    backgroundColor: "#016099",
    backgroundColorScheme: ["#016099", "#13426B"],
    // light mode
    // backgroundColor: "#f3ff6a",
    // backgroundColorScheme: ["#f3ff6a", "#dde860", "#cbd559"],
    media: {
      // image
      // imageUrl: "https://placehold.co/600x360",
      // photoID: 8265775,
      // type: "image",
      // video
      // videoUrl: `https://www.youtube.com/embed/dQw4w9WgXcQ`,
      videoUrl: `https://player.vimeo.com/video/56562874`,
      type: "video",
    },
    options: {
      allowMultipleItemSignups: 0,
      shared: 1,
      public: 1,
      expireDate: 0,
      sendReminderAt: 0,
      showConfetti: 1,
    },
    signupListVerbs: {
      ID: 1,
      title: "an Event",
      entity: "spot",
      entityPlural: "spots",
      actionName: "Sign Up",
      actionAsATitle: "Sign up for",
      actionNamePresentTense: "signing up",
      cancelName: "Cancel",
      howManyQuestion: "How many people are coming?",
      confirmOne: "you're in!",
      confirmMultiple: "you're in for # people!",
      cancelOne: "We've cancelled your spot for this event.",
      cancelMultiple: "We've cancelled your spots for this event.",
      status: 1,
    },
    signupListStatusID: 1,
    scheduledReminderSent: [],
    manualRemindersSent: [],
    signupListTypeID: 1,
    fundIt: {
      hasSignupCost: true,
      blockAutomaticRefunds: false,
      isSuggestedDonation: false,
      fund: {
        ID: 1005,
        name: "Signup Fund - Paid Event Yo",
        confirmationMessage: "",
        signupPaymentsCollected: false,
      },
      cost: {
        costType: "PerSignup",
        amounts: [
          {
            numberOfSlots: 2,
            amount: 300,
            ID: 1791,
          },
          {
            numberOfSlots: null,
            amount: 500,
            ID: 1792,
          },
        ],
      },
    },
    fund: {
      ID: 5,
      name: "Signup - Testing",
      confirmationMessage: null,
      signupPaymentsCollected: false,
    },
    blockAutomaticRefunds: true,
    signupItems: [
      {
        ID: 8,
        title: "Basic",
        description: "",
        type: 1,
        totalSlots: 20,
        slotsTaken: 3,
        maxSingleUserSlots: 5,
        orderNumber: 0,
        hasSignupCost: true,
        amount: 500,
        costType: "PerSlot",
        fundName: "Signup - Testing",
        respondents: [
          {
            isHousehold: true,
            householdTitle: "The Admin Household",
            householdID: 1,
            numberOfSlots: 2,
            householdRespondents: [
              {
                additionalNameID: 68,
                fname: "Garry",
                lname: null,
                paymentStatus: null,
                markedPaidRecorderName: null,
                isAdditionalName: true,
              },
              {
                additionalNameID: 69,
                fname: "Super",
                lname: "Admin",
                paymentStatus: null,
                markedPaidRecorderName: null,
                userID: 2,
                name: "Super Admin",
                numberOfSlots: 2,
                userSignupHistory: [
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1671220057,
                        dateString: "Dec 16 at 2:47 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "JZ7Z",
                      signedUpViaIcon: "faExternalLink",
                      details: { slots: 1, additionalNames: [] },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 4,
                      created: {
                        timestamp: 1671225873,
                        dateString: "Dec 16 at 4:24 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "JZ7Z",
                      signedUpViaIcon: "faExternalLink",
                      details: { switchedToItemID: null },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1671225878,
                        dateString: "Dec 16 at 4:24 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "HND6",
                      signedUpViaIcon: "faExternalLink",
                      details: { slots: 1, additionalNames: [] },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1671226014,
                        dateString: "Dec 16 at 4:26 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "HND6",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 1, after: 1 },
                        additionalNames: {
                          before: [],
                          after: [],
                          added: [],
                          removed: [],
                          autoDeleted: [],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1671229119,
                        dateString: "Dec 16 at 5:18 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "HES8",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 1, after: 1 },
                        additionalNames: {
                          before: [],
                          after: [],
                          added: [],
                          removed: [],
                          autoDeleted: [],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1671229584,
                        dateString: "Dec 16 at 5:26 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "Y5KB",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 1, after: 1 },
                        additionalNames: {
                          before: [],
                          after: [],
                          added: [],
                          removed: [],
                          autoDeleted: [],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 4,
                      created: {
                        timestamp: 1673544397,
                        dateString: "Jan 12 at 12:26 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "DLFZ",
                      signedUpViaIcon: "faUsersMedical",
                      details: { switchedToItemID: null },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1673544432,
                        dateString: "Jan 12 at 12:27 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "ILMG",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: 2,
                        additionalNames: [
                          { fname: "Garry" },
                          {
                            fname: "Super",
                            lname: "Admin",
                            isUserWhoSignedUp: true,
                          },
                        ],
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1673544508,
                        dateString: "Jan 12 at 12:28 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "ILMG",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 1, after: 3 },
                        additionalNames: {
                          before: [{ fname: "Garry", lname: null }],
                          after: [
                            { fname: "Garry" },
                            { fname: "Ted" },
                            { fname: null, lname: null },
                          ],
                          added: [
                            { fname: "Garry" },
                            { fname: "Ted" },
                            { fname: null, lname: null },
                          ],
                          removed: [{ fname: "Garry", lname: null }],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1673544539,
                        dateString: "Jan 12 at 12:28 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "2ELJ",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 3, after: 3 },
                        additionalNames: {
                          before: [
                            { fname: null, lname: null },
                            { fname: "Ted", lname: null },
                            { fname: "Garry", lname: null },
                          ],
                          after: [
                            { fname: "Garry" },
                            { fname: "Ted" },
                            { fname: null, lname: null },
                          ],
                          added: [{ fname: "Garry" }, { fname: "Ted" }],
                          removed: [
                            { fname: "Ted", lname: null },
                            { fname: "Garry", lname: null },
                          ],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 4,
                      created: {
                        timestamp: 1673544546,
                        dateString: "Jan 12 at 12:29 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "CENH",
                      signedUpViaIcon: "faExternalLink",
                      details: { switchedToItemID: null },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1673544558,
                        dateString: "Jan 12 at 12:29 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "LBT2",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: 2,
                        additionalNames: [
                          { fname: "Garry" },
                          {
                            fname: "Super",
                            lname: "Admin",
                            isUserWhoSignedUp: true,
                          },
                        ],
                      },
                    },
                  },
                ],
                userSignupID: 30,
                householdID: 1,
              },
            ],
          },
          {
            additionalNameID: 16,
            fname: "Test",
            lname: null,
            paymentStatus: null,
            markedPaidRecorderName: null,
            userID: 53,
            name: "Test",
            numberOfSlots: 1,
            userSignupHistory: [
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671228933,
                    dateString: "Dec 16 at 5:15 PM",
                    userInfo: { ID: 53, fname: "Test", lname: "" },
                  },
                  confirmationNumber: "AILE",
                  signedUpViaIcon: "faExternalLink",
                  details: { slots: 1, additionalNames: [] },
                },
              },
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 2,
                  created: {
                    timestamp: 1671229151,
                    dateString: "Dec 16 at 5:19 PM",
                    userInfo: { ID: 53, fname: "Test", lname: "" },
                  },
                  confirmationNumber: "AILE",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: { before: 1, after: 2 },
                    additionalNames: {
                      before: [],
                      after: [{ fname: "Test2" }],
                      added: [{ fname: "Test2" }],
                      removed: [],
                      autoDeleted: [],
                    },
                  },
                },
              },
            ],
            userSignupID: 8,
            householdID: 0,
          },
        ],
        cancelledRespondents: [
          {
            userID: 52,
            name: "Suzy Admin",
            fname: "Suzy",
            userSignupHistory: [
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671220057,
                    dateString: "Dec 16 at 2:47 PM",
                    userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                  },
                  confirmationNumber: "966Z",
                  signedUpViaIcon: "faExternalLink",
                  details: { slots: 1, additionalNames: [] },
                },
              },
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 4,
                  created: {
                    timestamp: 1671225873,
                    dateString: "Dec 16 at 4:24 PM",
                    userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                  },
                  confirmationNumber: "966Z",
                  signedUpViaIcon: "faExternalLink",
                  details: { switchedToItemID: null },
                },
              },
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671226014,
                    dateString: "Dec 16 at 4:26 PM",
                    userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                  },
                  confirmationNumber: "22G6",
                  signedUpViaIcon: "faExternalLink",
                  details: { slots: 1, additionalNames: [] },
                },
              },
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 2,
                  created: {
                    timestamp: 1671229119,
                    dateString: "Dec 16 at 5:18 PM",
                    userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                  },
                  confirmationNumber: "22G6",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: { before: 1, after: 1 },
                    additionalNames: {
                      before: [],
                      after: [],
                      added: [],
                      removed: [],
                      autoDeleted: [],
                    },
                  },
                },
              },
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 4,
                  created: {
                    timestamp: 1671229481,
                    dateString: "Dec 16 at 5:24 PM",
                    userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                  },
                  confirmationNumber: "A73L",
                  signedUpViaIcon: "faExternalLink",
                  details: { switchedToItemID: null },
                },
              },
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671229584,
                    dateString: "Dec 16 at 5:26 PM",
                    userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                  },
                  confirmationNumber: "DQ6J",
                  signedUpViaIcon: "faExternalLink",
                  details: { slots: 1, additionalNames: [] },
                },
              },
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 4,
                  created: {
                    timestamp: 1671289763,
                    dateString: "Dec 17 at 10:09 AM",
                    userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                  },
                  confirmationNumber: "DQ6J",
                  signedUpViaIcon: "faExternalLink",
                  details: { switchedToItemID: null },
                },
              },
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1673544432,
                    dateString: "Jan 12 at 12:27 PM",
                    userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                  },
                  confirmationNumber: "ATXE",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: 1,
                    additionalNames: [
                      {
                        fname: "Suzy",
                        lname: "Admin",
                        isUserWhoSignedUp: true,
                      },
                    ],
                  },
                },
              },
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 2,
                  created: {
                    timestamp: 1673544508,
                    dateString: "Jan 12 at 12:28 PM",
                    userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                  },
                  confirmationNumber: "ATXE",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: { before: 0, after: 2 },
                    additionalNames: {
                      before: [],
                      after: [
                        { fname: null, lname: null },
                        { fname: null, lname: null },
                      ],
                      added: [
                        { fname: null, lname: null },
                        { fname: null, lname: null },
                      ],
                      removed: [],
                    },
                  },
                },
              },
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 2,
                  created: {
                    timestamp: 1673544539,
                    dateString: "Jan 12 at 12:28 PM",
                    userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                  },
                  confirmationNumber: "NGZB",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: { before: 2, after: 2 },
                    additionalNames: {
                      before: [
                        { fname: null, lname: null },
                        { fname: null, lname: null },
                      ],
                      after: [
                        { fname: null, lname: null },
                        { fname: null, lname: null },
                      ],
                      added: [],
                      removed: [],
                    },
                  },
                },
              },
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 4,
                  created: {
                    timestamp: 1673544546,
                    dateString: "Jan 12 at 12:29 PM",
                    userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                  },
                  confirmationNumber: "WFJK",
                  signedUpViaIcon: "faExternalLink",
                  details: { switchedToItemID: null },
                },
              },
              {
                signupListItem: { ID: 9, title: "Fancy" },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1673545666,
                    dateString: "Jan 12 at 12:47 PM",
                    userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                  },
                  confirmationNumber: "TDJ3",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: 1,
                    additionalNames: [
                      {
                        fname: "Suzy",
                        lname: "Admin",
                        isUserWhoSignedUp: true,
                      },
                    ],
                  },
                },
              },
            ],
          },
        ],
      },
      {
        ID: 9,
        title: "Fancy",
        description: "",
        type: 1,
        totalSlots: 20,
        slotsTaken: 1,
        maxSingleUserSlots: 5,
        orderNumber: 1,
        hasSignupCost: true,
        amount: 1000,
        costType: "PerSlot",
        fundName: "Signup - Testing",
        respondents: [
          {
            isHousehold: true,
            householdTitle: "The Admin Household",
            householdID: 1,
            numberOfSlots: 1,
            householdRespondents: [
              {
                additionalNameID: 70,
                fname: "Suzy",
                lname: "Admin",
                paymentStatus: null,
                markedPaidRecorderName: null,
                userID: 52,
                name: "Suzy Admin",
                numberOfSlots: 1,
                userSignupHistory: [
                  {
                    signupListItem: { ID: 9, title: "Fancy" },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1673545666,
                        dateString: "Jan 12 at 12:47 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "TDJ3",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: 1,
                        additionalNames: [
                          {
                            fname: "Suzy",
                            lname: "Admin",
                            isUserWhoSignedUp: true,
                          },
                        ],
                      },
                    },
                  },
                ],
                userSignupID: 31,
                householdID: 1,
              },
            ],
          },
        ],
        cancelledRespondents: [],
      },
      {
        ID: 10,
        title: "Basic",
        description: "",
        type: 1,
        totalSlots: 20,
        slotsTaken: 3,
        maxSingleUserSlots: 5,
        orderNumber: 0,
        hasSignupCost: true,
        amount: 500,
        costType: "PerSlot",
        fundName: "Signup - Testing",
        respondents: [
          {
            isHousehold: true,
            householdTitle: "The Admin Household",
            householdID: 1,
            numberOfSlots: 2,
            householdRespondents: [
              {
                additionalNameID: 68,
                fname: "Garry",
                lname: null,
                paymentStatus: null,
                markedPaidRecorderName: null,
                isAdditionalName: true,
              },
              {
                additionalNameID: 69,
                fname: "Super",
                lname: "Admin",
                paymentStatus: null,
                markedPaidRecorderName: null,
                userID: 2,
                name: "Super Admin",
                numberOfSlots: 2,
                userSignupHistory: [
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1671220057,
                        dateString: "Dec 16 at 2:47 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "JZ7Z",
                      signedUpViaIcon: "faExternalLink",
                      details: { slots: 1, additionalNames: [] },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 4,
                      created: {
                        timestamp: 1671225873,
                        dateString: "Dec 16 at 4:24 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "JZ7Z",
                      signedUpViaIcon: "faExternalLink",
                      details: { switchedToItemID: null },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1671225878,
                        dateString: "Dec 16 at 4:24 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "HND6",
                      signedUpViaIcon: "faExternalLink",
                      details: { slots: 1, additionalNames: [] },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1671226014,
                        dateString: "Dec 16 at 4:26 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "HND6",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 1, after: 1 },
                        additionalNames: {
                          before: [],
                          after: [],
                          added: [],
                          removed: [],
                          autoDeleted: [],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1671229119,
                        dateString: "Dec 16 at 5:18 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "HES8",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 1, after: 1 },
                        additionalNames: {
                          before: [],
                          after: [],
                          added: [],
                          removed: [],
                          autoDeleted: [],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1671229584,
                        dateString: "Dec 16 at 5:26 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "Y5KB",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 1, after: 1 },
                        additionalNames: {
                          before: [],
                          after: [],
                          added: [],
                          removed: [],
                          autoDeleted: [],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 4,
                      created: {
                        timestamp: 1673544397,
                        dateString: "Jan 12 at 12:26 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "DLFZ",
                      signedUpViaIcon: "faUsersMedical",
                      details: { switchedToItemID: null },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1673544432,
                        dateString: "Jan 12 at 12:27 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "ILMG",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: 2,
                        additionalNames: [
                          { fname: "Garry" },
                          {
                            fname: "Super",
                            lname: "Admin",
                            isUserWhoSignedUp: true,
                          },
                        ],
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1673544508,
                        dateString: "Jan 12 at 12:28 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "ILMG",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 1, after: 3 },
                        additionalNames: {
                          before: [{ fname: "Garry", lname: null }],
                          after: [
                            { fname: "Garry" },
                            { fname: "Ted" },
                            { fname: null, lname: null },
                          ],
                          added: [
                            { fname: "Garry" },
                            { fname: "Ted" },
                            { fname: null, lname: null },
                          ],
                          removed: [{ fname: "Garry", lname: null }],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1673544539,
                        dateString: "Jan 12 at 12:28 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "2ELJ",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 3, after: 3 },
                        additionalNames: {
                          before: [
                            { fname: null, lname: null },
                            { fname: "Ted", lname: null },
                            { fname: "Garry", lname: null },
                          ],
                          after: [
                            { fname: "Garry" },
                            { fname: "Ted" },
                            { fname: null, lname: null },
                          ],
                          added: [{ fname: "Garry" }, { fname: "Ted" }],
                          removed: [
                            { fname: "Ted", lname: null },
                            { fname: "Garry", lname: null },
                          ],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 4,
                      created: {
                        timestamp: 1673544546,
                        dateString: "Jan 12 at 12:29 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "CENH",
                      signedUpViaIcon: "faExternalLink",
                      details: { switchedToItemID: null },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1673544558,
                        dateString: "Jan 12 at 12:29 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "LBT2",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: 2,
                        additionalNames: [
                          { fname: "Garry" },
                          {
                            fname: "Super",
                            lname: "Admin",
                            isUserWhoSignedUp: true,
                          },
                        ],
                      },
                    },
                  },
                ],
                userSignupID: 30,
                householdID: 1,
              },
            ],
          },
          {
            additionalNameID: 16,
            fname: "Test",
            lname: null,
            paymentStatus: null,
            markedPaidRecorderName: null,
            userID: 53,
            name: "Test",
            numberOfSlots: 1,
            userSignupHistory: [
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671228933,
                    dateString: "Dec 16 at 5:15 PM",
                    userInfo: { ID: 53, fname: "Test", lname: "" },
                  },
                  confirmationNumber: "AILE",
                  signedUpViaIcon: "faExternalLink",
                  details: { slots: 1, additionalNames: [] },
                },
              },
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 2,
                  created: {
                    timestamp: 1671229151,
                    dateString: "Dec 16 at 5:19 PM",
                    userInfo: { ID: 53, fname: "Test", lname: "" },
                  },
                  confirmationNumber: "AILE",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: { before: 1, after: 2 },
                    additionalNames: {
                      before: [],
                      after: [{ fname: "Test2" }],
                      added: [{ fname: "Test2" }],
                      removed: [],
                      autoDeleted: [],
                    },
                  },
                },
              },
            ],
            userSignupID: 8,
            householdID: 0,
          },
        ],
      },
      {
        ID: 11,
        title: "Basic",
        description: "",
        type: 1,
        totalSlots: 20,
        slotsTaken: 3,
        maxSingleUserSlots: 5,
        orderNumber: 0,
        hasSignupCost: true,
        amount: 500,
        costType: "PerSlot",
        fundName: "Signup - Testing",
        respondents: [
          {
            isHousehold: true,
            householdTitle: "The Admin Household",
            householdID: 1,
            numberOfSlots: 2,
            householdRespondents: [
              {
                additionalNameID: 68,
                fname: "Garry",
                lname: null,
                paymentStatus: null,
                markedPaidRecorderName: null,
                isAdditionalName: true,
              },
              {
                additionalNameID: 69,
                fname: "Super",
                lname: "Admin",
                paymentStatus: null,
                markedPaidRecorderName: null,
                userID: 2,
                name: "Super Admin",
                numberOfSlots: 2,
                userSignupHistory: [
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1671220057,
                        dateString: "Dec 16 at 2:47 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "JZ7Z",
                      signedUpViaIcon: "faExternalLink",
                      details: { slots: 1, additionalNames: [] },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 4,
                      created: {
                        timestamp: 1671225873,
                        dateString: "Dec 16 at 4:24 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "JZ7Z",
                      signedUpViaIcon: "faExternalLink",
                      details: { switchedToItemID: null },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1671225878,
                        dateString: "Dec 16 at 4:24 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "HND6",
                      signedUpViaIcon: "faExternalLink",
                      details: { slots: 1, additionalNames: [] },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1671226014,
                        dateString: "Dec 16 at 4:26 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "HND6",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 1, after: 1 },
                        additionalNames: {
                          before: [],
                          after: [],
                          added: [],
                          removed: [],
                          autoDeleted: [],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1671229119,
                        dateString: "Dec 16 at 5:18 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "HES8",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 1, after: 1 },
                        additionalNames: {
                          before: [],
                          after: [],
                          added: [],
                          removed: [],
                          autoDeleted: [],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1671229584,
                        dateString: "Dec 16 at 5:26 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "Y5KB",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 1, after: 1 },
                        additionalNames: {
                          before: [],
                          after: [],
                          added: [],
                          removed: [],
                          autoDeleted: [],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 4,
                      created: {
                        timestamp: 1673544397,
                        dateString: "Jan 12 at 12:26 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "DLFZ",
                      signedUpViaIcon: "faUsersMedical",
                      details: { switchedToItemID: null },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1673544432,
                        dateString: "Jan 12 at 12:27 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "ILMG",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: 2,
                        additionalNames: [
                          { fname: "Garry" },
                          {
                            fname: "Super",
                            lname: "Admin",
                            isUserWhoSignedUp: true,
                          },
                        ],
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1673544508,
                        dateString: "Jan 12 at 12:28 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "ILMG",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 1, after: 3 },
                        additionalNames: {
                          before: [{ fname: "Garry", lname: null }],
                          after: [
                            { fname: "Garry" },
                            { fname: "Ted" },
                            { fname: null, lname: null },
                          ],
                          added: [
                            { fname: "Garry" },
                            { fname: "Ted" },
                            { fname: null, lname: null },
                          ],
                          removed: [{ fname: "Garry", lname: null }],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 2,
                      created: {
                        timestamp: 1673544539,
                        dateString: "Jan 12 at 12:28 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "2ELJ",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: { before: 3, after: 3 },
                        additionalNames: {
                          before: [
                            { fname: null, lname: null },
                            { fname: "Ted", lname: null },
                            { fname: "Garry", lname: null },
                          ],
                          after: [
                            { fname: "Garry" },
                            { fname: "Ted" },
                            { fname: null, lname: null },
                          ],
                          added: [{ fname: "Garry" }, { fname: "Ted" }],
                          removed: [
                            { fname: "Ted", lname: null },
                            { fname: "Garry", lname: null },
                          ],
                        },
                      },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 4,
                      created: {
                        timestamp: 1673544546,
                        dateString: "Jan 12 at 12:29 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "CENH",
                      signedUpViaIcon: "faExternalLink",
                      details: { switchedToItemID: null },
                    },
                  },
                  {
                    signupListItem: { ID: 8, title: "Basic" },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1673544558,
                        dateString: "Jan 12 at 12:29 PM",
                        userInfo: { ID: 2, fname: "Super", lname: "Admin" },
                      },
                      confirmationNumber: "LBT2",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: 2,
                        additionalNames: [
                          { fname: "Garry" },
                          {
                            fname: "Super",
                            lname: "Admin",
                            isUserWhoSignedUp: true,
                          },
                        ],
                      },
                    },
                  },
                ],
                userSignupID: 30,
                householdID: 1,
              },
            ],
          },
          {
            additionalNameID: 16,
            fname: "Test",
            lname: null,
            paymentStatus: null,
            markedPaidRecorderName: null,
            userID: 53,
            name: "Test",
            numberOfSlots: 1,
            userSignupHistory: [
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671228933,
                    dateString: "Dec 16 at 5:15 PM",
                    userInfo: { ID: 53, fname: "Test", lname: "" },
                  },
                  confirmationNumber: "AILE",
                  signedUpViaIcon: "faExternalLink",
                  details: { slots: 1, additionalNames: [] },
                },
              },
              {
                signupListItem: { ID: 8, title: "Basic" },
                event: {
                  ID: 2,
                  created: {
                    timestamp: 1671229151,
                    dateString: "Dec 16 at 5:19 PM",
                    userInfo: { ID: 53, fname: "Test", lname: "" },
                  },
                  confirmationNumber: "AILE",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: { before: 1, after: 2 },
                    additionalNames: {
                      before: [],
                      after: [{ fname: "Test2" }],
                      added: [{ fname: "Test2" }],
                      removed: [],
                      autoDeleted: [],
                    },
                  },
                },
              },
            ],
            userSignupID: 8,
            householdID: 0,
          },
        ],
      },
    ],
  },
  notes: [],
  network: { ID: 2, name: "Test Net" },
  user: {
    ID: 2,
    firstName: "Super",
    lastName: "Admin",
    email: {
      ID: 2,
      type: "email",
      status: "active",
      verified: true,
      address: "superadmin@testnet.com",
    },
    isAdminOfAnyGroup: true,
    canSignupHouseholdMembers: true,
    household: [{ userID: 52, fname: "Suzy", lname: "Admin" }],
    householdID: 1,
    canViewGiving: true,
  },
  userSignupItems: {
    8: {
      count: 2,
      respondents: [
        {
          userSignupItemID: 31,
          name: "Garry",
          isAdditionalName: true,
          userID: null,
          additionalNameID: 68,
          paymentStatus: "Paid",
        },
        {
          userSignupItemID: 31,
          name: "Super Admin",
          isAdditionalName: false,
          userID: 2,
          additionalNameID: 69,
          paymentStatus: "Paid",
        },
      ],
    },
    9: {
      count: 1,
      respondents: [
        {
          userSignupItemID: 32,
          name: "Suzy Admin",
          isAdditionalName: false,
          userID: 52,
          additionalNameID: 70,
          paymentStatus: "Unpaid",
        },
      ],
    },
  },
  allSignupListTypes: [
    { ID: 1, title: "an Event" },
    { ID: 2, title: "Seats" },
    { ID: 4, title: "a Poll" },
    { ID: 5, title: "Items" },
    { ID: 7, title: "Volunteers" },
  ],
  isApp: false,
  userID: 2,
};
